import script from "./AppIntro.vue?vue&type=script&setup=true&lang=js"
export * from "./AppIntro.vue?vue&type=script&setup=true&lang=js"

import "./AppIntro.vue?vue&type=style&index=0&id=0c8d1c9c&scoped=true&lang=css"

import exportComponent from "/var/www/project/coridor-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0c8d1c9c"]])

export default __exports__